import { useState } from 'react'
import styled from 'styled-components'
import ConversationBlock from './ConversationBlock'
import { useBottomsheet } from '../../hooks/useBottomSheet'
import AddMeaningBottomSheet from './AddMeaningBottomSheet'
import MainButton from '../atoms/MainButton'
import Text from '../atoms/Text'
import { logEvent } from '../../utils/eventLogger'
import RecommendWordGuideSheet from './RecommendWordGuideSheet'

const Wrapper = styled.div`
  padding: 20px 0 84px 0;
  background-color: ${(props) => props.theme.colors.neutral[100]};
  min-height: calc(100vh - 56px - 97px - 76px);
`
const ConversationWrapper = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
  gap: 30px;
`
const ActionSecction = styled.div`
  width: 100%;
  max-width: 600px;
  padding: 0 20px;
  margin: 36px 0 20px 0;
`
const ButtonWrapper = styled.div`
  width: 100%; 
  display: flex;
  gap: 12px;
`
const GuideMessage = styled.div`
  text-align: left;
  margin-bottom: 12px;
`
const MobileBr = styled.br`
  display: none;
  @media (max-width: 600px) {
    display: inline;
  }
`
const TranscriptSection = ({ hrId, $isEditable, data, newMeanings, onMeaningChange, setNewMeanings, onLater, onSubmit, onSeek }) => {

  const [expandedIdx, setExpandedIdx] = useState(null);
  const [selectedWord, setSelectedWord] = useState(null);

  const toggleExpand = (idx) => {
    setExpandedIdx(prev => (prev === idx ? null : idx));
    // console.log('확장될 단어블록', expandedIdx)
  };

  const bottomSheet = useBottomsheet(); // 바텀시트 훅 호출

  const openAddMeaningSheet = (word) => {
    setSelectedWord(word);
    bottomSheet.open('addMeaning');
  };

  const handleSaveMeaning = (meaning) => {
    setNewMeanings(prev => ({
      ...prev,
      [selectedWord.key]: {
        addedMeaning: meaning,
        selectedMeaning: meaning,
        selectedRank: 99
      },
    }));

    // 로그 기록
    logEvent("labeling_submit", {
      hrId: hrId,
      drId: selectedWord.drId, // 추후 백엔드 데이터 연결
      labelMethod: "user_input",
      seqNo: 99
    });

    bottomSheet.close();
    setSelectedWord(null);
  };

  const handleRemoveAddedMeaning = (key, drId) => {
    setNewMeanings(prev => {
      // 해당 단어에 상태가 없으면 그대로
      if (!prev[key]) return prev;

      const { addedMeaning, selectedMeaning, ...rest } = prev[key];

      return {
        ...prev,
        [key]: {
          ...rest, // 다른 필드 유지
          addedMeaning: null, // 추가 의미 삭제
          selectedMeaning: selectedMeaning === addedMeaning ? null : selectedMeaning,
          selectedRank: 0
        }
      };
    });

    // 로그 기록
    logEvent("labeling_submit", {
      hrId: hrId,
      drId: drId, // 추후 백엔드 데이터 연결
      labelMethod: "cancel",
      seqNo: 99
    });

  };

  const openGuideSheet = () => {
    bottomSheet.open('guide');
  }

  const bottomSheetComponents = {
    addMeaning: () => (
      <AddMeaningBottomSheet
        $isOpen={bottomSheet.isOpen} 
        onClose={bottomSheet.close} 
        word={selectedWord}
        onSaveMeaning={handleSaveMeaning}
      />
    ),
    guide: () => (
      <RecommendWordGuideSheet
        $isOpen={bottomSheet.isOpen} 
        onClose={bottomSheet.close}/>
    )
  }

  const CurrentBottomSheet = bottomSheet.sheetType ? bottomSheetComponents[bottomSheet.sheetType] : null;
  
  return (
    <Wrapper>
      <ConversationWrapper>
        {data && data.map((item) => (
        <ConversationBlock
          hrId={hrId}
          item={item} 
          key={item.sequence}
          parentIdx={item.sequence}
          expandedIdx={$isEditable ? expandedIdx : undefined}
          toggleExpand={$isEditable ? toggleExpand : undefined}
          $isEditable={$isEditable}
          word={selectedWord}
          newMeanings={newMeanings}
          onMeaningChange={onMeaningChange}
          onAddMeaningClick={openAddMeaningSheet}
          onRemoveAddedMeaning={handleRemoveAddedMeaning}
          onHelpClick={openGuideSheet}
          onSeek={onSeek}
        />
      ))}
      </ConversationWrapper>
      {$isEditable &&
        <ActionSecction>
          <GuideMessage>
            <Text variant="caption" color="alternative">
              한 번 저장된 내용은 수정이 불가능합니다. <MobileBr /> 
              추가 검토가 필요한 내용이 있으면 ‘나중에 검토하기’를 선택해주세요.
            </Text>
          </GuideMessage>
          <ButtonWrapper>
            <MainButton 
              $variant="cancel"
              title="나중에 검토하기"
              onClick={onLater}
            />
            <MainButton 
              $variant="primary"
              title="저장하기"
              onClick={onSubmit}/>
          </ButtonWrapper>
        </ActionSecction>
      }
      {CurrentBottomSheet && <CurrentBottomSheet/>}
    </Wrapper>
  )
}

export default TranscriptSection
